import React from "react";
import Seo from "@/components/Seo";

export default function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <Seo title="Datenschutzerklärung – HELIUM" description="Informationen zum Datenschutz (DSGVO) bei HELIUM Catering UG." />
      <h1 className="text-3xl font-extrabold font-display">Datenschutzerklärung</h1>
      <div className="mt-6 space-y-4 text-gray-700 text-sm leading-relaxed">
        <p>Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003).</p>
        <h2 className="text-lg font-semibold text-gray-900">1. Verantwortlicher</h2>
        <p>HELIUM Catering UG (haftungsbeschränkt), E-Mail: info@helium-catering.de</p>
        <h2 className="text-lg font-semibold text-gray-900">2. Erhobene Daten</h2>
        <p>Bei der Registrierung erheben wir Vor- und Nachname, E-Mail-Adresse und optional Telefonnummer sowie Ihren bevorzugten Standort. Diese Daten dienen der Verwaltung Ihres Kundenkontos und des Treueprogramms.</p>
        <h2 className="text-lg font-semibold text-gray-900">3. Ihre Rechte</h2>
        <p>Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch. Ihr Konto können Sie jederzeit unter „Mein Konto → Konto löschen" entfernen und Ihre Daten exportieren.</p>
        <h2 className="text-lg font-semibold text-gray-900">4. Marketing & Einwilligung</h2>
        <p>Marketing-E-Mails erhalten Sie nur mit Ihrer ausdrücklichen Einwilligung. Diese können Sie jederzeit widerrufen (Abmeldung).</p>
        <h2 className="text-lg font-semibold text-gray-900">5. Datenminimierung</h2>
        <p>Wir erheben nur die für den jeweiligen Zweck notwendigen Daten. Ihr QR-Code enthält ausschließlich ein zufälliges Token – keine personenbezogenen Daten.</p>
      </div>
    </div>
  );
}
